module.exports = __webpack_public_path__ + "static/media/archive.271e4649.svg";